import React from 'react';
import WindowLayout from '../WindowLayout';
import WindowOptions from '../WindowOptions';
import WindowIconTitle from '../WindowIconTitle';
import DocumentsLayouter from '../DocumentsLayouter';
import Icon from '../Icon';
import { FormattedHTMLMessage } from 'react-intl';
import { formatRoute } from 'react-router-named-routes';
import { NavLink } from 'react-router-dom';
import { PDF } from '../../routes';

const Documents = ({ history, game }) => (
	<WindowLayout>
		<WindowLayout.Header>
			<WindowOptions history={history} />
			<WindowIconTitle
				className="documents-window-icon-title"
				icon={'folderResults'}
				title={'Documents'}
			/>
		</WindowLayout.Header>
		<WindowLayout.Body>
			<DocumentsLayouter>
				<FormattedHTMLMessage id="documents" />
				<FormattedHTMLMessage id="documents-description" />
				<NavLink to={formatRoute(PDF, { gameID: game.id, pdfID: 'thecase' })}>
					<Icon icon={'docdocument'} />
					<span className="medium-font">
						<FormattedHTMLMessage id="pdf-case" />
					</span>
				</NavLink>
				<NavLink
					to={formatRoute(PDF, { gameID: game.id, pdfID: 'guidelines' })}
				>
					<Icon icon={'pdfdocument'} />
					<span className="medium-font">
						<FormattedHTMLMessage id="pdf-guidelines" />
					</span>
				</NavLink>
				<NavLink to={formatRoute(PDF, { gameID: game.id, pdfID: 'howtoplay' })}>
					<Icon icon={'pdfdocument'} />
					<span className="medium-font">
						<FormattedHTMLMessage id="pdf-howtoplay" />
					</span>
				</NavLink>
			</DocumentsLayouter>
		</WindowLayout.Body>
	</WindowLayout>
);

export default Documents;
